import { render, staticRenderFns } from "./SendResetCode.vue?vue&type=template&id=51fe1c4e&"
import script from "./SendResetCode.vue?vue&type=script&lang=js&"
export * from "./SendResetCode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports